import { hasAnyScope, hasScope } from "@kontextwerk/web-common";

import { getToken } from "./auth";

export type Scope =
  | "kw:read"
  | "kw:realm-admin"
  | "kw:org-admin"
  | "kw:cross-org-read"
  | "kw:platform-admin";

export function isPlatformAdmin(): boolean {
  return hasScope(getToken(), "kw:platform-admin");
}

export function isOrgAdmin(): boolean {
  return hasAnyScope(getToken(), ["kw:org-admin", "kw:platform-admin"]);
}

export function isRealmAdmin(): boolean {
  return hasAnyScope(getToken(), [
    "kw:realm-admin",
    "kw:org-admin",
    "kw:platform-admin",
  ]);
}

export type EffectiveRole = "platform-admin" | "org-admin" | "realm-admin" | "read-only";

export function effectiveRole(): EffectiveRole {
  if (isPlatformAdmin()) return "platform-admin";
  if (isOrgAdmin()) return "org-admin";
  if (isRealmAdmin()) return "realm-admin";
  return "read-only";
}
